import * as types from './mutation-types';

const mutations = {
  [types.SET_UNIT_SITE_EXCLUSION_ENABLED](state, enabled) {
    state.siteUnitExclusionEnabled = enabled;
  },
  [types.SET_CREATIVE_WEIGHTING_ENABLED](state, enabled) {
    state.creativeWeightingEnabled = enabled;
  },
  [types.SET_MARKET_TARGETING_ENABLED](state, enabled) {
    state.marketTargetingEnabled = enabled;
  },
};

export default mutations;
